<template>
  <div
    class="relative"
    :class="{
      'pb-48': isNotStartPage,
    }"
  >
    <ListCategories
      :categories="categories"
      :selected-category-id="selectedCategoryId"
      @set-category="(id) => selectedCategoryId = id"
    />
    <div class="container md:grid md:grid-cols-3 gap-24">
      <ListItem
        v-for="look in looks"
        :key="look.id"
        :look="look"
      />
    </div>
    <div>
      <div class="w-full overflow-hidden sm:pt-32">
        <component
          :is="BlockComponents[component.layout]"
          v-for="(component, idx) in pageDocument.components"
          :key="component.layout + idx"
          v-bind="{ component }"
          :has-side-bar="hasSideBar"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Page from '~/models/page';
import BlockComponents from '~/constants/block-components';
import type { ContentData, LooksData } from '~/constants/types/page';
import { useConfigStore } from '~/store/config';
import ListCategories from '~/components/shop-the-look/ListCategories.vue';
import ListItem from '~/components/shop-the-look/ListItem.vue';

export type ExtendedCategories = {
  name: string;
  id: string;
  count: number;
};

const config = useConfigStore();
const route = useRoute();
const props = defineProps<{
  page: ContentData,
}>();

const pageDocument = computed(()=> {
  return new Page({ contentData: props.page });
});

const selectedCategoryId = ref('');

const links = computed(()=>{
  return props.page.sidebar_links ? props.page.sidebar_links : [];
});

const isNotStartPage = computed(()=>{
  return !config.startPageUrls.includes(
    `${process.env.FRONTEND_URL}${route.fullPath}`
  );
});
const hasSideBar = computed(()=>{
  return links.value.length > 0;
});
const categories = computed<ExtendedCategories[]>(()=>{
  return pageDocument.value.categories.map((i) => {
    const count = pageDocument.value.looks.reduce(
      (prev, cur) => (cur.categories.includes(i.id) ? ++prev : prev),
      0
    );
    return {
      ...i,
      count,
    };
  });
});
const looks = computed<LooksData[]>(()=>{
  return pageDocument.value.looks.filter((i) => {
    return (
      selectedCategoryId.value === '' ||
      i.categories.includes(selectedCategoryId.value)
    );
  });
});

</script>

<style scoped lang="postcss">
</style>
